import { Typography, Paper, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import React from 'react';
import { useHistory } from 'react-router';
import { Container } from 'reactstrap';
import { isNullOrUndefined } from '../Util';
import { FormatDataByTypeCode } from './FormScripts';
import NavMenu from './NavMenu';

export var changePath;

// Context for child components to register a refresh handler
export const RefreshContext = React.createContext(null);

export function Layout(props) {
  const [path, setPath] = React.useState(document.location.pathname.toLowerCase())
  const [refreshHandler, setRefreshHandler] = React.useState(null);
  changePath = (newPath) => {
    setPath(newPath)
  }

  const history = useHistory();

  history.listen(() => {
    changePath(document.location.pathname.toLocaleLowerCase());
  });

  React.useEffect(() => {
    setPath(document.location.pathname.toLowerCase());
  }, [])

  const shouldShowNav = !path.includes("/landing") && !path.includes("/mainmenu") && !path.includes("/check-in-kiosk");
  return (
    <div style={{ height: "100%" }}>
      <NavMenu changeFacility={props.changeFacility} hidden={!shouldShowNav} />
      <Container style={{ height: "calc(100% - 42px)" }}>
        <Paper sx={{ padding: 2, height: "100%", overflowY: "auto" }}>
          {!isNullOrUndefined(props.navText) &&
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6">{props.navText + " - " + FormatDataByTypeCode(new Date(), "D")}</Typography>
              {refreshHandler && (
                <IconButton onClick={refreshHandler} size="small" title="Refresh">
                  <RefreshIcon />
                </IconButton>
              )}
            </div>
          }
          <RefreshContext.Provider value={setRefreshHandler}>
            {props.children}
          </RefreshContext.Provider>
        </Paper>
      </Container>
    </div>
  );

}
